import { StLine } from './Line.styled'

import type { LineProps } from './Line.types'

const Line = (props: LineProps) => <StLine {...props} />

export { Line }
